import { render, staticRenderFns } from "./money-input.vue?vue&type=template&id=cdb4f09a&"
import script from "./money-input.vue?vue&type=script&lang=ts&"
export * from "./money-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports